import styled from "styled-components";

const LoadAndErrorContainer = styled.div`
  display: flex;
  width: 100%;
  height: 250px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: #f5f5f5;
`;

export { LoadAndErrorContainer };
